export const headTbl = (total) => {
    const sizePerPageList = [
        {
            text: '25',
            value: 25,
        },
        {
            text: '50',
            value: 50,
        },
        {
            text: '100',
            value: 100,
        },
        {
            text: 'Todos',
            value: total,
        },
    ];
    return sizePerPageList;
};
export const TblHZonas = {
    id: { estado: true, texto: 'ID' },
    nombre: { estado: true, texto: 'Nombre' },
    descr: { estado: false, texto: 'Descripción' },
    oltn: { estado: true, texto: 'Olt' },
    action: { estado: true, texto: 'Acción' },
};
export const tblAutos = {
    id: { estado: true, texto: 'ID' },
    modelo: { estado: true, texto: 'Modelo' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHOnus = {
    cliente: { estado: true, texto: 'Cliente' },
    nameolt: { estado: true, texto: 'Olt' },
    status: { estado: true, texto: 'Estado' },
    seynal: { estado: true, texto: 'Señal' },
    port_pon: { estado: true, texto: 'Puerto' },
    sub: { estado: true, texto: 'Subpuerto' },
    name: { estado: true, texto: 'Descripción' },
    mac: { estado: true, texto: 'Mac' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHAnuncios = {
    keey: { estado: true, texto: 'Clave' },
    tipo: { estado: true, texto: 'Tipo' },
    foto: { estado: true, texto: 'Imagen' },
    nombre: { estado: true, texto: 'Nombre' },
    descripcion: { estado: false, texto: 'descripción' },
    emit: { estado: true, texto: 'Emitido por' },
    clientes: { estado: true, texto: 'Clientes' },
    pendientes: { estado: true, texto: 'Pendientes' },
    enviados: { estado: true, texto: 'Enviados' },
    fecha: { estado: true, texto: 'fecha' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHAnunciosUS = {
    type: { estado: true, texto: 'Tipo' },
    foto: { estado: true, texto: 'Imagen' },
    nombre: { estado: true, texto: 'Nombre' },
    descripcion: { estado: false, texto: 'descripción' },
    ipe: { estado: true, texto: 'Emitido por' },
    clientes: { estado: true, texto: 'Clientes' },
    fecha: { estado: true, texto: 'fecha' },
    estate: { estado: true, texto: 'Estado' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHspeeds = {
    id: { estado: true, texto: 'ID' },
    nombre: { estado: true, texto: 'Nombre' },
    costo: { estado: true, texto: 'costo' },
    limit_down: { estado: true, texto: 'Bajada KBPS' },
    limit_up: { estado: true, texto: 'Subida KBPS' },
    descripcion: { estado: false, texto: 'Descripción' },
    active: { estado: true, texto: 'Activos' },
    susp: { estado: true, texto: 'Suspendidos' },
    pro: { estado: false, texto: 'Promosión' },

    action: { estado: true, texto: 'Acción' },
};
export const TblHBox = {
    descripcion: { estado: true, texto: 'Nombre' },
    olt: { estado: true, texto: 'Olt' },
    zona: { estado: true, texto: 'zona' },
    ubicacion: { estado: false, texto: 'ubicaciòn' },
    coordenadas: { estado: true, texto: 'coordenadas' },
    puertos: { estado: true, texto: 'puertos' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHRouters = {
    id: { estado: true, texto: 'ID' },
    nodo: { estado: true, texto: 'Nombre' },
    ip: { estado: true, texto: 'ip' },
    modelo: { estado: true, texto: 'modelo' },
    version: { estado: false, texto: 'versión' },
    clie: { estado: true, texto: 'clientes' },
    susp: { estado: true, texto: 'suspendidos' },
    estado: { estado: true, texto: 'estado' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHIpv4 = {
    id: { estado: true, texto: 'ID' },
    nombre: { estado: true, texto: 'Nombre' },
    red: { estado: true, texto: 'red' },
    used: { estado: true, texto: 'Uso de IPS' },
    cidr: { estado: false, texto: 'CIDR' },
    namenodo: { estado: true, texto: 'Router' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHEmis = {
    id: { estado: true, texto: 'ID' },
    nombre: { estado: true, texto: 'Nombre' },
    equipo: { estado: true, texto: 'equipo' },
    ip: { estado: true, texto: 'ip' },
    estado: { estado: true, texto: 'estado' },
    onl: { estado: false, texto: 'Online' },
    active: { estado: true, texto: 'Activos' },
    susp: { estado: true, texto: 'Susp...' },
    ipv4s: { estado: true, texto: 'Redes' },
    zona: { estado: false, texto: 'Zona' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHPlanes = {
    id: { estado: true, texto: 'ID' },
    plan: { estado: true, texto: 'Nombre' },
    limit_down: { estado: true, texto: 'Bajada KBPS' },
    limit_up: { estado: true, texto: 'Subida KBPS' },
    costo: { estado: true, texto: 'costo' },
    active: { estado: true, texto: 'Activos' },

    susp: { estado: true, texto: 'Suspendidos' },
    pro: { estado: false, texto: 'Promoción' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHbajas = {
    id: { estado: true, texto: 'ID' },
    nombre: { estado: true, texto: 'Nombre' },
    desc: { estado: true, texto: 'Descripción' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHClientes = {
    id: { estado: true, texto: 'ID' },
    ser_tipo: { estado: false, texto: 'Tipo' },
    nombre: { estado: true, texto: 'Nombre' },
    estado: { estado: true, texto: 'estado' },
    ip: { estado: true, texto: 'ip' },
    mac: { estado: true, texto: 'mac' },
    status_user: { estado: true, texto: 'estatus' },
    zona: { estado: true, texto: 'zona' },
    plan: { estado: true, texto: 'plan' },
    ultimo_pago: { estado: true, texto: 'ultimo pago' },
    mk: { estado: false, texto: 'mikrotik' },
    direccion_principal: { estado: false, texto: 'direcciòn principal' },
    movil: { estado: false, texto: 'movil' },
    telefono: { estado: false, texto: 'Teléfono' },
    coordenadas: { estado: false, texto: 'coordenadas' },
    fechapago: { estado: false, texto: 'fecha corte' },
    otro: { estado: false, texto: 'Otro servicio' },
    notaotro: { estado: false, texto: 'Nota O.S' },
    otestado: { estado: false, texto: 'Estado O.S' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHEmpelados = {
    id: { estado: true, texto: 'ID' },
    nombre: { estado: true, texto: 'Nombre' },
    direccion: { estado: true, texto: 'direción' },
    telefono: { estado: true, texto: 'telefono' },
    inicio_labores: { estado: true, texto: 'Inicio de labores' },
    estado: { estado: true, texto: 'Estado' },
    vale: { estado: true, texto: 'vale' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHinstall = {
    id: { estado: true, texto: 'ID' },
    ser_tipo: { estado: true, texto: 'Tipo' },
    cliente: { estado: true, texto: 'Nombre' },
    zonaname: { estado: true, texto: 'Ubicación' },
    fecha_ingreso: { estado: true, texto: 'Fecha' },
    fecha_instalacion: { estado: true, texto: 'Fecha Instalación' },
    direccion: { estado: true, texto: 'direcciòn' },
    movil: { estado: true, texto: 'Móvil' },
    estate: { estado: true, texto: 'estado' },
    ide: { estado: false, texto: 'Ide' },
    agente: { estado: false, texto: 'agente' },
    motivo: { estado: false, texto: 'Motivo' },
    action: { estado: true, texto: 'Acción' },
};

export const Tbltareas = {
    id_tarea: { estado: true, texto: 'ID' },
    fecha: { estado: true, texto: 'Fecha' },
    // tipo_tarea: { estado: true, texto: 'Tipo' },
    lider: { estado: true, texto: 'Lider' },
    ayudantes: { estado: true, texto: 'ayudantes' },
    tarea: { estado: true, texto: 'Tarea' },

    estado: { estado: true, texto: 'estado' },
    nota: { estado: false, texto: 'Nota' },
    action: { estado: true, texto: 'Acción' },
};
export const TbltareasEs = {
    id_tarea: { estado: true, texto: 'ID' },
    fecha: { estado: true, texto: 'Fecha' },
    tipo: { estado: true, texto: 'Tipo' },
    lider: { estado: true, texto: 'Lider' },
    ayudantes: { estado: true, texto: 'ayudantes' },

    estado: { estado: true, texto: 'estado' },
    action: { estado: true, texto: 'Acción' },
};
export const TbltareasMy = {
    id_tarea: { estado: true, texto: 'ID' },
    fecha: { estado: true, texto: 'Fecha' },

    lider: { estado: true, texto: 'Lider' },
    ayudantes: { estado: true, texto: 'ayudantes' },
    tarea: { estado: true, texto: 'Tarea' },

    estado: { estado: true, texto: 'estado' },
    nota: { estado: false, texto: 'Nota' },
    action: { estado: true, texto: 'Acción' },
};
export const TblActividades = {
    id: { estado: true, texto: 'ID' },
    tipo: { estado: true, texto: 'Tipo' },
    roll: { estado: true, texto: 'Mi Roll' },
    cliente: { estado: true, texto: 'Cliente' },
    fecha_inicio: { estado: true, texto: 'Fecha inicio' },
    fecha_fin: { estado: false, texto: 'Fecha fin' },
    operador: { estado: true, texto: 'Agente' },
    estado: { estado: true, texto: 'estado' },
    nota: { estado: false, texto: 'Nota' },
    obs: { estado: false, texto: 'Observación' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHPagos = {
    id: { estado: true, texto: 'ID' },
    nombre: { estado: true, texto: 'Cliente' },
    agente: { estado: true, texto: 'Agente' },
    forma_pago: { estado: true, texto: 'Forma pago' },
    folio: { estado: true, texto: '#Transacción' },
    fecha_pago: { estado: true, texto: 'Fecha & hora' },
    pagado: { estado: true, texto: 'Cobrado' },
    comision: { estado: true, texto: 'Comisión' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHInegreso = {
    ref: { estado: true, texto: 'Referencia' },
    fecha: { estado: true, texto: 'fecha' },
    monto: { estado: true, texto: 'Forma pago' },
    tipo: { estado: true, texto: 'Tipo' },
    name: { estado: true, texto: 'Operador' },
    descri: { estado: true, texto: 'descripción' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHSat = {
    fecha: { estado: true, texto: 'fecha' },
    nombre: { estado: true, texto: 'Cliente' },
    razon: { estado: true, texto: 'Razón' },
    rfc: { estado: true, texto: 'Rfc' },
    folio: { estado: true, texto: 'Folio' },
    total: { estado: true, texto: 'Total' },
    forma_pago: { estado: false, texto: 'Metodo de pago' },
    state: { estado: true, texto: 'Estado' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHSatGlo = {
    createdAt: { estado: true, texto: 'fecha' },
    rfc: { estado: true, texto: 'Rfc' },
    folio: { estado: true, texto: 'Folio' },
    subtotal: { estado: true, texto: 'subtotal' },
    iva: { estado: true, texto: 'iva' },
    total: { estado: true, texto: 'Total' },
    forma_p: { estado: true, texto: 'Forma pago' },
    state: { estado: true, texto: 'Estado' },
    action: { estado: true, texto: 'Acción' },
};
export const TblHTk = {
    id: { estado: true, texto: 'Nº' },
    folio: { estado: true, texto: 'Folio' },
    estado: { estado: true, texto: 'Estado' },
    cliente: { estado: true, texto: 'Remitente' },
    asunto: { estado: true, texto: 'asunto' },
    fecha_reporte: { estado: true, texto: 'Fecha reporte' },
    last_reply: { estado: true, texto: 'Ultima respuesta' },
    agente: { estado: false, texto: 'abierto por' },
    address: { estado: true, texto: 'Dirección' },
    zona: { estado: false, texto: 'zona' },
    fecha_cerrado: { estado: false, texto: 'fecha cerrado' },

    action: { estado: true, texto: 'Acción' },
};
export const TblHTkcl = {
    id: { estado: true, texto: 'Nº' },
    folio: { estado: true, texto: 'folio' },

    estado: { estado: true, texto: 'Estado' },
    cliente: { estado: true, texto: 'Remitente' },
    asunto: { estado: true, texto: 'asunto' },
    fecha_reporte: { estado: true, texto: 'Fecha Reporte' },
    last_reply: { estado: true, texto: 'Ultima respuesta' },
    agente: { estado: true, texto: 'abierto por' },
    zona: { estado: true, texto: 'zona' },
    fecha_cerrado: { estado: true, texto: 'fecha cerrado' },

    action: { estado: true, texto: 'Acción' },
};
export const TblHTkUs = {
    id: { estado: true, texto: 'Nº' },
    folio: { estado: true, texto: 'folio' },
    estado: { estado: true, texto: 'Estado' },
    cliente: { estado: true, texto: 'Remitente' },
    asunto: { estado: true, texto: 'asunto' },
    fecha_reporte: { estado: true, texto: 'Fecha Reporte' },
    last_reply: { estado: true, texto: 'Ultima respuesta' },
    fecha_cerrado: { estado: true, texto: 'Fecha cerrado' },
    agente: { estado: true, texto: 'Abierto por' },

    action: { estado: true, texto: 'Acción' },
};
export const TblZons = {
    id: { estado: true, texto: 'Nº' },
    zona: { estado: true, texto: 'Zona' },
    active: { estado: true, texto: 'Activos' },
    susp: { estado: true, texto: 'Suspendidos' },

    action: { estado: true, texto: 'Acción' },
};
export const TblRoles = {
    id: { estado: true, texto: 'Id' },
    rol: { estado: true, texto: 'Rol' },
    total: { estado: true, texto: 'Agentes' },
    // permisos: { estado: true, texto: 'Permisos' },

    action: { estado: true, texto: 'Acción' },
};
export const TblCortes = {
    monto: { estado: true, texto: 'Monto' },
    estado: { estado: true, texto: 'Estado' },
    fecha: { estado: true, texto: 'Fecha' },
    tipo: { estado: true, texto: 'Tipo' },
};
export const TblLogsLogin = {
    fecha: { estado: true, texto: 'Fecha' },
    uno: { estado: true, texto: 'Ip' },
    tres: { estado: true, texto: 'Usuario' },
    dos: { estado: true, texto: 'Detalle' },
};
export const TblLogsYS = {
    fecha: { estado: true, texto: 'Fecha' },
    uno: { estado: true, texto: 'Cliente' },
    tres: { estado: true, texto: 'Detalle' },
    dos: { estado: true, texto: 'Operador' },
    cuatro: { estado: false, texto: 'Data' },
};
export const TblLogsUser = {
    fecha: { estado: true, texto: 'Fecha' },
    tres: { estado: true, texto: 'Detalle' },
    dos: { estado: true, texto: 'Agente' },
    cuatro: { estado: false, texto: 'Data' },
};
export const TblAgentes = {
    id_agent: { estado: true, texto: 'Id' },

    name: { estado: true, texto: 'nombre' },
    user: { estado: true, texto: 'usuario' },
    email: { estado: false, texto: 'correo' },
    rol: { estado: true, texto: 'rol' },
    dpto: { estado: true, texto: 'departamento' },
    status: { estado: true, texto: 'status' },
    action: { estado: true, texto: 'Acción' },
};
export const TblDocs = {
    agente: { estado: true, texto: 'Creado por' },
    titulo: { estado: true, texto: 'titulo' },
    nota: { estado: true, texto: 'Descripción' },
    foto: { estado: true, texto: 'Archivo' },
    createdAt: { estado: true, texto: 'Fecha' },
    action: { estado: true, texto: 'Acción' },
};
export const TblmyPays = {
    id: { estado: true, texto: 'Creado por' },
    estado: { estado: true, texto: 'titulo' },
    type: { estado: true, texto: 'Descripción' },
    fecha_corte: { estado: true, texto: 'Archivo' },
    fecha_prox: { estado: true, texto: 'Fecha' },
    total: { estado: true, texto: 'total' },
    pagado: { estado: true, texto: 'pagado' },
    comision: { estado: false, texto: 'comisión' },
    fecha_pago: { estado: true, texto: 'Fecha pago' },
    forma_pago: { estado: true, texto: 'forma pago' },
    folio: { estado: true, texto: 'folio' },
    agente: { estado: true, texto: 'agente' },
    action: { estado: true, texto: 'Acción' },
};
